<template>

    <div class="row p-4 pl-5 pr-6 navigation-row">
        <div class="cell d-flex flex-align-center flex-wrap p-0 navigation-content">
            <h3 class="dashboard-section-title text-left-md m-0">
                <ul class="breadcrumbs py-3 pr-3">

                    <!-- Menu toggle -->
                    <!--<li>
                        <button class="ml-3 mr-3 button square" id="menu-toggle" @click.stop.prevent="toggleLeftMenu">
                            <span class="mif-2x mif-menu"></span>
                        </button>
                    </li>-->

                    <!-- Go back -->
                    <!--<li v-if="$route.path != '/dashboard' && $route.path != '/licenses'">
                        <button @click="$root.goBack()" class="page-link button p-0">
                            <i class="mif-arrow-left"></i>
                        </button>
                    </li>-->

                    <!-- Dashboard info -->
                    <li v-if="pageName === 'dashboard'" class="page-item">
                        <router-link to="/dashboard" class="page-link pl-0">
                            <div>
                                <div>
                                    <label>{{ $t("Dashboard") }}</label>
                                </div>
                                <h6 class="mt-2">
                                    {{ $t("License") }}: {{ $root.authObj.company }} ({{ $root.authObj.ma_username }})
                                </h6>
                            </div>
                        </router-link>
                    </li>

                    <!--Backup-->
                    <li v-if="['accounts', 'repositories', 'backupstats', 'backups', 'restores'].includes(pageName)" class="page-item pr-3"><span class="mr-1">{{ $t("Backup") }}</span></li>
                    <li v-if="pageName == 'accounts'" class="page-item"><router-link to="/accounts" class="page-item page-link">{{ $t("Credentials Locker") }}</router-link></li>
                    <li v-if="pageName == 'repositories'" class="page-item"><router-link to="/repo" class="page-item page-link">{{ $t("Backup Repositories") }}</router-link></li>
                    <li v-if="pageName == 'backupstats'" class="page-item"><router-link to="/backupstats" class="page-item page-link"><span class="mr-1 " />{{ $t("Backup statistics") }}</router-link></li>
                    <li v-if="pageName == 'backups'" class="page-item"><router-link to="/backups" class="page-item page-link">{{ $t("Backup Jobs") }}</router-link></li>
                    <li v-if="pageName == 'restores'" class="page-item"><router-link to="/restores" class="page-item  page-link">{{ $t("Restore history") }}</router-link></li>

                    <!-- Computer & Device Selector -->
                    <template v-if="pageName == 'computer' && pc && $root.forceRefreshID >= 0">
                        <li class="page-item">
                            <router-link to="/computers" class="page-link pl-0">{{ $t("Devices") }}</router-link>
                        </li>
                        <li class="page-item d-flex flex-align-center pl-3 mr-3" v-if="pcOptions.length!=0">
                            <router-link :to="'/computers/computer/' + pc.id" class="page-link pl-0">
                                <span class="mif-display"></span>
                            </router-link>
                            <!--select class="select input w-auto" @change="navigateToComputer">
      <option v-for="pc2 in $session.getPCList()" class="truncate-namepc" :title="pc2.pc_name + ' (' + pc2.organization_name + ')'" :key="pc2.id" :value="pc2.id" :disabled="pageName === 'backup' && data.editing" :selected="pc2.id === pc.id" :class="$root.connectionsStates[pc2.id] ? '' : 'fg-gray'" >
       {{ pc2.pc_name + ' (' + pc2.organization_name + ')' }}
      </option>
    </select-->
                            <select class="select input w-auto" v-model="selectedId" @change="navigateToComputer" :disabled="pageName === 'backup' && data.editing">
                                <option v-for="o in pcOptions" :selected="o.id === pc.id" :class="$root.connectionsStates[o.id] ? '' : 'fg-gray'" :key="o.id" :value="o.id" :title="o.full">
                                    {{ o.label }}
                                </option>
                            </select>

                        </li>
                    </template>

                    <!-- Dynamic Pages -->
                    <li v-if="pageName == 'backup'" class="page-item page-link">{{ data.editing ? data.backupName : $t("Create Backup") }}</li>
                    <li v-if="pageName == 'groups'" class="page-item"><router-link to="/groups" class="page-link pl-0">{{ $t("Groups") }}</router-link></li>
                    <li v-if="pageName == 'policies'" class="page-item"><router-link to="/policies" class="page-link pl-0">{{ $t("Policies") }}</router-link></li>
                    <li v-if="pageName == 'group'" class="page-item"><router-link :to="'/group/' + data.group.id" class="page-link pl-0">{{ data.group.name }}</router-link></li>
                    <li v-if="pageName == 'users'" class="page-item"><router-link to="/users" class="page-link pl-0">{{ $t("Users") }}</router-link></li>
                    <li v-if="pageName == 'scriptsinventory'" class="page-item"><router-link to="/scripts/inventory" class="page-link pl-0">{{ $t("Scripts inventory") }}</router-link></li>
                    <li v-if="pageName == 'scriptsdeployhistory'" class="page-item"><router-link to="/scripts/history" class="page-link pl-0">{{ $t("Deploy history") }}</router-link></li>
                    <template v-if="pageName == 'script'">
                        <li class="page-item"><router-link to="/scripts/inventory" class="page-link pl-0">{{ $t("Scripts inventory") }}</router-link></li>
                        <li class="page-item page-link">{{ data.scriptName || $t("Create New Script") }}</li>
                    </template>

                    <!-- Static links based on pageName -->
                    <li v-if="pageName === 'settings'" class="page-item"><router-link to="/settings" class="page-link pl-0">{{ $t("Privacy Settings") }}</router-link></li>
                    <li v-if="pageName === 'computers'" class="page-item"><router-link to="/computers" class="page-link pl-0">{{ $t("Devices") }}</router-link></li>
                    <li v-if="pageName === 'licenses'" class="page-item"><router-link to="/licenses" class="page-link pl-0">{{ $t("License") }}</router-link></li>
                    <li v-if="pageName === 'schedulation'" class="page-item"><router-link to="/scheduling" class="page-link pl-0">{{ $t("Backup Scheduling") }}</router-link></li>
                    <li v-if="pageName === 'auditLogs'" class="page-item"><router-link to="/auditlogs" class="page-link pl-0">{{ $t("Audit Logs") }}</router-link></li>

                    <!-- Special stats pages -->
                    <li v-if="['remotestats', 'sessions', 'activesessions', 'customclient'].includes(pageName)" class="page-item pr-3"><span class="mr-1">{{ $t("Remote Access") }}</span></li>
                    <li v-if="pageName == 'sessions'" class="page-item"><router-link to="/sessions" class="page-link page-item"><span class="mr-1 " />{{ $t("Sessions") }}</router-link></li>
                    <li v-if="pageName == 'activesessions'" class="page-item"><router-link to="/activesessions" class="page-link page-item"><span class="mr-1 " />{{ $t("Active Sessions") }}</router-link></li>
                    <li v-if="pageName == 'customclient'" class="page-item"><router-link to="/customclient" class="page-link page-item"><span class="mr-1 " />{{ $t("Custom client") }}</router-link></li>
                    <li v-if="pageName == 'remotestats'" class="page-item"><router-link to="/remotestats" class="page-item page-link"><span class="mr-1 " />{{ $t("Statistics") }}</router-link> </li>

                    <!-- Ticketing -->
                    <!--<li v-if="['ticket', 'tickets', 'teams'].includes(pageName)" class="page-item pr-3"><span class="mr-1">{{ $t("Ticketing") }}</span></li>-->
                    <li v-if="['ticket', 'tickets'].includes(pageName)" class="page-item"><router-link to="/tickets" class="page-item page-link pl-0"><span class="mr-1 " />{{ $t("Tickets") }}</router-link> </li>
                    <li v-if="pageName == 'ticket'" class="page-item"><router-link to="/tickets" class="page-item page-link"><span class="mr-1" />{{ data.ticketID ? data.ticketName : $t('Create new ticket') }}</router-link> </li>
                    <li v-if="['teams', 'team-view'].includes(pageName)" class="page-item"><router-link to="/teams" class="page-item page-link pl-0"><span class="mr-1 " />{{ $t("Teams") }}</router-link> </li>
                    <li v-if="pageName == 'team-view'" class="page-item"><router-link :to="'/teams/' + team.id" class="page-link page-item">{{ data.team.name }}</router-link></li>

                    <!-- Fatturazione -->
                    <!--<li v-if="['customers', 'invoices'].includes(pageName)" class="page-item pr-3"><span class="mr-1">{{ $t("Billing") }}</span></li>-->
                    <li v-if="pageName == 'customers'" class="page-item"><router-link to="/billing/clients" class="page-item page-link pl-0"><span class="mr-1" />{{ $t("Customers") }}</router-link> </li>
                    <li v-if="pageName == 'invoices'" class="page-item"><router-link to="/billing/invoices" class="page-item page-link pl-0"><span class="mr-1" />{{ $t("Invoices") }}</router-link> </li>



                </ul>
            </h3>



            <!--BOTTONI DESTRA-->
            <div class="cell d-flex flex-align-center flex-justify-end navigation-actions" :class="{ 'navigation-actions-computer': pageName == 'computer' }">
                <ul class="listview navigation-actions-list">

                    <!--COMPUTERS-->
                    <li v-if="pageName == 'computers' && !$root.noIperiusOneLicense">
                        <a class="button secondary" @click.prevent="toggleAgentBuilding">
                            <span class="icon mif-desktop_windows"></span>
                            <span>{{ $t("Add Device") }}</span>
                        </a>
                    </li>

                    <li v-if="pageName == 'groups'">
                        <a class="button secondary mr-1" @click="$root.$emit('OPENASSIGNGROUPSTOCUSTOMERSDIALOG')">
                            <span class="icon mif-2x mif-group_add"></span>
                            <span>{{ $t("Manage customer groups") }}</span>
                        </a>
                    </li>

                    <li v-if="pageName == 'groups'">
                        <a class="button secondary mr-1" @click="$root.$emit('OPENGROUPVIEWDIALOG')">
                            <span class="icon mif-2x mif-add"></span>
                            <span>{{ $t("Add Group") }}</span>
                        </a>
                    </li>

                    <li v-if="pageName == 'policies'">
                        <a class="button secondary mr-1" @click="$root.$emit('OPENPOLICYVIEWDIALOG', null, $session.getPCList())">
                            <span class="icon mif-2x mif-add"></span>
                            <span>{{ $t("Add Policy") }}</span>
                        </a>
                    </li>

                    <li v-if="pageName == 'scriptsinventory'">
						<router-link class="button secondary mr-1" to="/scripts/new">
                            <span class="icon mif-2x mif-add"></span>
                            <span>{{ $t("Add script") }}</span>
						</router-link>
                    </li>

					<li v-if="pageName == 'scriptsdeployhistory'">
						<a class="button secondary mr-1" @click="$root.$emit('OPENSCRIPTDEPLOYDIALOG')">
							<span class="icon mif-2x mif-add"></span>
							<span>{{ $t('Deploy script') }}</span>
						</a>
					</li>

                    <li v-if="pageName == 'settings'">
                        <a class="button secondary" @click="$root.requestNotificationPermission()"><span class="mif-notifications mif-2x mr-2"></span> {{ $t("Enable Web Notifications") }}</a>
                    </li>

                    <li v-if="pageName == 'users'">
                        <a class="button secondary mr-2" @click="$root.$emit('OPENUSERVIEWDIALOG')">
                            <span class="icon mif-2x mif-add"></span>
                            <span>{{ $t("Add User") }}</span>
                        </a>
                    </li>
                    <li v-if="pageName == 'computer'">
                        <ul class="h-menu bg-light d-flex flex-wrap flex-justify-end computer-actions-menu">
                            <li>
                                <div>
                                    <a v-if="pc.backup_license_status == 0" href="#" @click="$root.$emit('OPENBUYDIALOG')" class="dropdown-toggle button secondary mr-2 p-4 pr-4">{{ $t('Backup') }}</a>
                                    <a v-else href="#" class="dropdown-toggle button secondary mr-2 p-4 pr-4">{{ $t('Backup') }}</a>
                                    <ul v-if="pc.backup_license_status != 0" class="d-menu mt-2" data-role="dropdown">
                                        <li>
                                            <router-link :to="pc.backup_license_status == 0 ? '#' : this.$route.path + '/backup'" class="text-bold" :disabled="!$root.connectionsStates[pc.id]">
                                                {{ $t("Add backup job") }}
                                            </router-link>
                                        </li>
                                        <li>
                                            <a :disabled="!$root.connectionsStates[pc.id]" href="#" class="text-bold" @click="$root.$emit('OPENCONFRESTOREFROMBACKUPJOB', pc.id)">
                                                {{ $t('Restore from backup job') }}
                                            </a>
                                        </li>
                                        <li>
                                            <a :disabled="!$root.connectionsStates[pc.id]" href="#" class="text-bold dropdown-toggle">{{ $t('Restore from backup path') }} </a>
                                            <ul v-if="pc.backup_license_status != 0" class="d-menu mt-2" data-role="dropdown">
                                                <!-- Header / Title -->
                                                <li class="menu-title pl-8 py-2">
                                                    <span><b>{{ $t("Backup type") }}</b></span>
                                                </li>
                                                <li class="divider"></li>
                                                <template v-if="$ONEServiceTypeInfo != null" v-for="t in restoreTypes">
                                                    <li v-if="t == 5" v-for="microsoft_t in $root.getMicrosoftTypes()" :key="microsoft_t">
                                                        <a @click="$root.$emit('OPENRESTOREDIALOG', microsoft_t, null)" :disabled="!$root.connectionsStates[pc.id] || pc.backup_license_status == 0">
                                                            Microsoft <b>{{ $ONEServiceTypeInfo[microsoft_t].name }}</b>
                                                        </a>
                                                    </li>
                                                    <li v-if="t != 5">
                                                        <a @click="$root.$emit('OPENRESTOREDIALOG', t, null)" :disabled="!$root.connectionsStates[pc.id] || pc.backup_license_status == 0">
                                                            <b>{{ $ONEServiceTypeInfo[t].name }}</b>
                                                        </a>
                                                    </li>
                                                </template>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li>
                                <PCRemoteLink :pc="pc" complete="true" />
                            </li>
                            <li>
                                <div :disabled="!$root.connectionsStates[pc.id] || pc.backup_license_status == 0">
                                    <a class="ml-2 button secondary" @click="$root.$emit('openCMD')"><span class="mif-2x mif-external mr-1"></span> {{ $t("Open Command Prompt") }}</a>
                                </div>
                            </li>

                            <li v-if="$root.hiddenFeature">
                                <div :disabled="!$root.connectionsStates[pc.id] || pc.backup_license_status == 0">
                                    <a class="ml-2 button secondary" @click="$root.$emit('OPENDOWNLOADITEMSDIALOG')">
                                        <span class="mif-2x mif-download mr-1"></span>
                                        <span>{{ $t("Download files/folders") }}</span>
                                    </a>
                                </div>
                            </li><!---->

                        </ul>
                    </li>

                    <li v-if="pageName == 'backups'">
                        <a class="button secondary mr-1" @click="$root.$emit('OPENSELECTPCFORBACKUP')">
                            <span class="icon mif-2x mif-add"></span>
                            <span>{{ $t("Create Backup Job") }}</span>
                        </a>
                    </li>
                    <li v-if="pageName == 'licenses'">
                        <a class="button secondary mr-1" :href="ssoUpgradeUrl" target="_blank">
                            <span class="icon mif-2x mif-add_moderator"></span>
                            <span>{{ $t("Upgrade your license") }}</span>
                        </a>
                    </li>

                    <li v-if="pageName == 'teams' && $root.authObj.roles == 'Admin'">
                        <a class="button secondary mr-1" @click="$root.$emit('OPENTEAMDIALOG', null)">
                            <span class="mif-plus mr-1"></span>
                            <span>{{ $t("Add team") }}</span>
                        </a>
                    </li>

                    <li v-if="pageName == 'team-view'">
                        <a class="button secondary mr-1" @click="$root.$emit('OPENTEAMDIALOG', team)">
                            <span class="mif-pencil mr-1"></span>{{ $t("Edit") }}
                        </a>
                    </li>

                    <li v-if="pageName == 'team-view'">
                        <a class="button alert mr-1" v-if="$root.authObj.roles == 'Admin'" @click="deleteTeam(team)">
                            <span class="mif-bin mr-1"></span>{{ $t("Delete") }}
                        </a>
                    </li>

                    <li v-if="pageName == 'customers' && $root.authObj.roles == 'Admin'">
                        <a class="button secondary mr-1" @click="$root.$emit('OPENCUSTOMERDIALOG', null)">
                            <span class="mif-plus mr-1"></span>
                            <span>{{ $t("Add customer") }}</span>
                        </a>
                    </li>

                    <li v-if="pageName == 'tickets' && $root.authObj.roles == 'Admin'">
                        <router-link class="button secondary mr-1" to="/ticket">
                            <span class="mif-plus mr-1"></span>
                            <span>{{ $t("Add ticket") }}</span>
                        </router-link>
                    </li>

                    <li v-if="pageName == 'invoices' && $root.authObj.roles == 'Admin'">
                        <a href="#" class="button secondary mr-1text-bold dropdown-toggle">
                            <span class="mif-plus mr-1"></span>
                            <span>{{ $t("Generate invoice") }}</span>
                        </a>
                        <ul class="d-menu mt-2" data-role="dropdown">
                            <li>
                                <a @click="$root.$emit('OPENINVOICEDIALOG', 'tickets')">
                                    {{ $t("Select tickets") }}
                                </a>
                            </li>
                            <li>
                                <a @click="$root.$emit('OPENINVOICEDIALOG', 'range')">
                                    {{ $t("Select date range") }}
                                </a>
                            </li>
                        </ul>
                    </li>

                </ul>
            </div>
        </div>
    </div>
</template>
<script>

import PCRemoteLink from '../../components/utils/PCRemoteLink.vue';
import { deleteTeam } from '../../utils/entityMethods/team.js';
export default {
    name: "Navigation",
    components: {
        "PCRemoteLink": PCRemoteLink,
    },
    props: {
        pageName: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            required: false
        },
        ssoUpgradeUrl: {
            type: String,
            required: false
        }
    },
    /*created() {
        console.log(this.data);
    },*/
    data() {
        return {
            // questo è l'array che contiene le voci di sottomenu del bottone restore backup
            restoreTypes: [
                this.$ONEServiceType.FileFolder,
                this.$ONEServiceType.Network,
                this.$ONEServiceType.Microsoft_OneDriveForBusiness,
                this.$ONEServiceType.Microsoft_SharePoint,
                this.$ONEServiceType.Microsoft_Teams,
                this.$ONEServiceType.Microsoft_Exchange365,
                this.$ONEServiceType.HyperV,
                this.$ONEServiceType.Database_SQLServer
            ],
            selectedId: this.data?.pc?.id ?? null,
            ellipsisLen: 40, // lunghezza max visualizzata
            pcOptions: [],
            pcOptionsTimer: null,

        }
    },
    computed: {
        pc() {
            return this.data.pc;
        },

        team() {
            return this.data.team;
        }
    },
    methods: {

        loadPCOptionsWhenAvailable() {
            if (!this.$session.hasPCList()) return false;

            this.pcOptions = (this.$session.getPCList() || []).map(pc2 => {
                let item = `${pc2.pc_name || ''}`;

                if (pc2.organization_name) {
                    item += ` (${pc2.organization_name})`;
                }

                const isOnline = !!this.$root.connectionsStates?.[pc2.id];
                const statusTag = isOnline ? '' : ' [offline]';

                return {
                    id: pc2.id,
                    full: item + statusTag,
                    label: this.ellipsis(item, this.ellipsisLen)
                };
            });

            this.stopPCOptionsTimer();
            return true;
        },

        startPCOptionsTimer() {
            if (this.loadPCOptionsWhenAvailable() || this.pcOptionsTimer != null) return;

            this.pcOptionsTimer = setInterval(() => {
                this.loadPCOptionsWhenAvailable();
            }, 250);
        },

        stopPCOptionsTimer() {
            if (this.pcOptionsTimer == null) return;
            clearInterval(this.pcOptionsTimer);
            this.pcOptionsTimer = null;
        },

        ellipsis(str, max) {
            if (!str) return '';
            const s = String(str);
            return s.length > max ? s.slice(0, max - 1) + '…' : s;
        },

        toggleAgentBuilding() {
            // Assicurati che il charms esista nel DOM
            const el = document.querySelector('#agentbuilding');
            if (!el || !window.Metro) return;

            // Inizializza il plugin se non lo è già (più robusto di usare window.Metro.charms)
            let charms = Metro.getPlugin(el, 'charms');
            if (!charms) {
                // inizializza solo il nodo/contesto necessario
                try { Metro.init(el); } catch (e) { }
                charms = Metro.getPlugin(el, 'charms');
            }

            if (charms && typeof charms.toggle === 'function') {
                charms.toggle();
            } else {
                console.warn('Charms non disponibile su #agentbuilding');
            }
        },
        toggleLeftMenu() {
            const sb = window.Metro.getPlugin('#main_menu', 'sidebar');
            if (!sb) return;
            sb.isOpen() ? sb.close() : sb.open();
            //sb.toggle();        // oppure: sb.open();  // se vuoi solo “espandere”
        },


        navigateToComputer(event) {
            var currentRoomPC = this.$session.getRoomPC();
            var newRoomPCID = event.target.value; // Ottieni l'ID del computer selezionato
            var newURL;
            if (currentRoomPC == null) {
                newURL = "/computers/computer/" + newRoomPCID;
            } else {
                newURL = this.$route.path.replace(currentRoomPC.id, newRoomPCID);
            }

            this.$router.replace({ path: newURL });
            this.$router.push(newURL);
            window.location.href = newURL;
        },

        deleteTeam
    },
    mounted() {
        if (this.pageName === 'computer') {
            this.startPCOptionsTimer();
        }
    },
    beforeDestroy() {
        this.stopPCOptionsTimer();
    }
}
</script>
